import { Getter, Mutation, State } from 'vuex-simple';
import { serverProps } from '@/Common/Environment/const';

export class HelpCenterServiceModule {
	constructor() {
		this.setIsEnabled(serverProps.showContextHelp);
		this.setBaseUrl(serverProps.contextHelpUrl);
	}

	@Getter()
	public get backendBaseUrl(): string {
		return '/aps/2/services/helpcenter-manager';
	}

	@State()
	public helpCenterVueIFrame?: HTMLIFrameElement;

	@Mutation()
	public setHelpCenterVueIFrame(vueIFrame: HTMLIFrameElement): void {
		this.helpCenterVueIFrame = vueIFrame;
	}

	@State()
	public componentName: string = '';

	@Mutation()
	public setComponentName(value: string): void {
		this.componentName = value;
	}

	@State()
	public version: string = '';

	@Mutation()
	public setVersion(value: string): void {
		this.version = value;
	}

	@State()
	public isLoading: boolean = false;

	@Mutation()
	public setIsLoading(value: boolean): void {
		this.isLoading = value;
	}

	@State()
	public baseUrl: string = '';

	@Mutation()
	public setBaseUrl(value: string = ''): void {
		this.baseUrl = value.replace(/\/+$/, '');
	}

	@State()
	public isEnabled: boolean = false;

	@Mutation()
	public setIsEnabled(value: boolean): void {
		this.isEnabled = value;
	}

	@State()
	public isHelpCenterOpened: boolean = false;

	@Mutation()
	public setIsHelpCenterOpened(value: boolean): void {
		if (this.isHelpCenterOpened === value) {
			return;
		}
		this.isHelpCenterOpened = value;
	}
}

const helpCenterServiceModule = new HelpCenterServiceModule();

export default helpCenterServiceModule;
